import { render, staticRenderFns } from "./group-button.component.vue?vue&type=template&id=09c39578&scoped=true"
import script from "./group-button.component.vue?vue&type=script&lang=js"
export * from "./group-button.component.vue?vue&type=script&lang=js"
import style0 from "./group-button.component.vue?vue&type=style&index=0&id=09c39578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c39578",
  null
  
)

export default component.exports